/**
 * @file Footer.tsx
 * @summary Composant global
 *
 * Composant transverse utilisé dans plusieurs pages (header, footer, SEO, layout…).
 *
 * @see docs/07-CODEBASE.md — conventions de code
 * @see docs/02-FRONTEND.md — design system (tokens HSL, typographie)
 */
import { Link } from "react-router-dom";
import { Facebook, Instagram, MapPin, Mail } from "lucide-react";


export default function Footer() {
  return (
    <footer className="bg-charcoal text-charcoal-foreground">
      <div className="container max-w-[1200px] mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Contact */}

          {/* Contact */}
          <div>
            <h4 className="text-lg mb-4 text-gold">Contact</h4>
            <ul className="space-y-3 text-sm font-body normal-case">
              <li className="flex items-start gap-2">
                <MapPin size={16} className="mt-0.5 shrink-0 text-gold" />
                <span>37 rue Pierre et Marie Curie, 69780 Saint-Pierre-de-Chandieu</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={16} className="shrink-0 text-gold" />
                <a href="mailto:contact@crossfitchistera.com" className="hover:text-gold transition-colors">
                  contact@crossfitchistera.com
                </a>
              </li>
            </ul>
            <div className="flex gap-4 mt-6">
              <a href="https://www.facebook.com/share/1DyTHxfnuD/" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" aria-label="Facebook">
                <Facebook size={22} />
              </a>
              <a href="https://www.instagram.com/crossfitchistera?igsh=bzJocjNtZGI1cDF3" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" aria-label="Instagram">
                <Instagram size={22} />
              </a>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-lg mb-4 text-gold">Informations générales et légales</h4>
            <ul className="space-y-2 text-sm font-body normal-case">
              <li><Link to="/legal/mentions" className="hover:text-gold transition-colors">Mentions légales</Link></li>
              <li><Link to="/legal/cgu" className="hover:text-gold transition-colors">CGU</Link></li>
              <li><Link to="/legal/cgv" className="hover:text-gold transition-colors">CGV</Link></li>
              <li><Link to="/legal/rgpd" className="hover:text-gold transition-colors">Politique RGPD</Link></li>
              <li><Link to="/lexique" className="hover:text-gold transition-colors">Lexique CrossFit</Link></li>
              <li><Link to="/charges" className="hover:text-gold transition-colors">Mes charges / PR</Link></li>
              <li><Link to="/rdv-services" className="hover:text-gold transition-colors">RDV Services</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-charcoal-foreground/20 mt-12 pt-8 flex flex-col gap-2 items-center text-center text-xs text-charcoal-foreground/50 font-body normal-case">
          <p>© {new Date().getFullYear()} MOJO SARL - CrossFit Chistera. Tous droits réservés.</p>
          <p>CrossFit est une marque de CrossFit, LLC. CrossFit Chistera est une salle de CrossFit affiliée à CrossFit, LLC</p>
        </div>
      </div>
    </footer>
  );
}
